import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useRegisterMutation } from '../../features/auth/authApi';
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';

const StudentRegistration = () => {
    const navigate = useNavigate()
    const [submitToRegister, { isLoading, isError, isSuccess, data: resData, error }] = useRegisterMutation()
    const { register, reset, handleSubmit, watch, formState: { errors } } = useForm();
    const onSubmit = data => {
        submitToRegister(data)
    };

    useEffect(() => {
        if (isSuccess) {
            navigate(`/course`)
            toast.success('Welcome to the Course ' + resData.user.name)

        }
        if (isError) {
            if (error.status === 400) {
                toast.error(error.data)
            } else {
                toast.error("Something went wrong.")
                reset()
            }

        }
    }, [isSuccess, isError, navigate, resData?.user?.name, error, reset])
    const isSubmitDisabled = watch('password') !== watch('confirm-password')
    const password = watch('password')
    return (
        <section className="py-6 bg-primary h-screen grid place-items-center">
            <div className="mx-auto max-w-md px-5 lg:px-0">
                <div>
                    <Link to='/'>
                        <img className="h-12 mx-auto" src="/image/learningportal.svg" />
                    </Link>
                    <h2 className="mt-6 text-center text-3xl font-extrabold text-slate-100">
                        Create Your New Account
                    </h2>
                </div>
                <form onSubmit={handleSubmit(onSubmit)} className="mt-8 space-y-6"  >
                    <input type="hidden" name="remember" value="true" />
                    <div className="rounded-md shadow-sm -space-y-px">

                        <div>
                            <label htmlFor="name" className="sr-only">Name</label>
                            <input id="name" name="name"  {...register("name", { required: true })} type="name" autoComplete="name" required
                                className="login-input rounded-t-md" placeholder="Student Name" />
                        </div>
                        <div>
                            <label htmlFor="email-address" className="sr-only">Email address</label>
                            <input id="email-address"  {...register("email", { required: true })} name="email" type="email" autoComplete="email" required
                                className="login-input " placeholder="Email address" />
                        </div>
                        <div>
                            <label htmlFor="password" className="sr-only">Password</label>
                            <input  {...register("password", { required: true, pattern: /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[@#$%^&+=!])(?!.*\s).{6,}$/ })} id="password" name="password" type="password" autoComplete="current-password" required
                                className="login-input" placeholder="Password" />

                            {errors.password?.type === "pattern" && (
                                <p className='text-error py-2'>Password must be have one number one text one special symbol and at least 8 characters long  </p>
                            )}
                        </div>
                        <div>
                            <label htmlFor="confirmPassword" className="sr-only">Confirm Password</label>
                            <input id="confirmPassword" name="confirmPassword"
                                {...register('confirmPassword', {
                                    required: true,
                                    validate: (value) => value === password || "The passwords do not match",
                                })}
                                type="password"
                                autoComplete="confirm-password" required className="login-input rounded-b-md"
                                placeholder="Confirm Password" />
                            {errors.confirmPassword?.message && <p className=' py-2 text-error'>
                                <FontAwesomeIcon icon={faCircleExclamation}></FontAwesomeIcon>
                                <span className='ml-2'>{errors.confirmPassword.message}!</span></p>}
                        </div>
                    </div>
                    <div className="flex items-center justify-end">
                        <div className="text-sm">
                            <Link to='/'>

                                <button type='button' className="font-medium text-violet-600 hover:text-violet-500">
                                    Already have a Account
                                </button>
                            </Link>
                        </div>
                    </div>
                    <div>
                        <button
                            disabled={isLoading}
                            type="submit"
                            className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500">
                            Create Account
                        </button>
                    </div>
                </form>
            </div>
        </section>
    );
};

export default StudentRegistration;